import { ComponentType } from 'react';
import { ArraySelectOptionType } from '@portals/ui-kit';
import { TColorType, TCustomColor } from '@portals/ui-kit/lib/chips/types';
import { EBlocksNames, EColors } from '@/_types';

export enum EHeaderModifier {
  TRANSPARENT = 'transparent',
  WHITE_TRANSPARENT = 'white-transparent',
  WHITE = 'white',
}

type THeaderLink = {
  id: EBlocksNames;
  title: string;
  routeName: string;
  icon?: ComponentType<{ color?: EColors }>;
  isMenuLink?: boolean;
};

export type THeaderButton = {
  text: string;
  color?: TColorType;
  colorHex?: TCustomColor;
  textHex?: TCustomColor;
};

export type THeaderConfig = {
  countries: ArraySelectOptionType;
  headerLinks: Array<THeaderLink>;
  headerPopupLinks: Array<THeaderLink>;
  loginButton: THeaderButton;
  registerButton: THeaderButton;
  languages?: ArraySelectOptionType;
};
